import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { Button, Grid, Input, Dropdown } from 'semantic-ui-react';

import { QUESTION_STATUS_OPTIONS } from 'components/modules/questions/constants';
import { QuestionGroupType } from 'components/modules/questions/types';
import { getGroupOptions } from 'components/modules/questions/utils';
import useDebounce from 'hooks/useDebounce';

const propTypes = {
  groups: PropTypes.arrayOf(QuestionGroupType).isRequired,
  onFiltersChange: PropTypes.func.isRequired,
  onCreateQuestion: PropTypes.func.isRequired,
};

const defaultProps = {};

const DEBOUNCE_MS = 1000;

export default function QuestionsFilters({ groups, onFiltersChange, onCreateQuestion }) {
  const [searchInput, setSearchInput] = useState('');
  const [selectedGroup, setSelectedGroup] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');

  const searchQuery = useDebounce(searchInput, DEBOUNCE_MS);

  const groupOptions = [{ key: 'all', text: 'All Groups', value: '' }, ...getGroupOptions(groups)];
  const statusOptions = [{ key: 'all', text: 'All Status', value: '' }, ...QUESTION_STATUS_OPTIONS];

  useEffect(() => {
    onFiltersChange({
      searchQuery,
      selectedGroup,
      selectedStatus,
    });
  }, [searchQuery, selectedGroup, selectedStatus]);

  function onSearchChange(e, { value }) {
    setSearchInput(value);
  }

  function onGroupFilterChange(e, { value }) {
    setSelectedGroup(value);
  }

  function onStatusFilterChange(e, { value }) {
    setSelectedStatus(value);
  }

  function onClearFilters() {
    setSearchInput('');
    setSelectedGroup('');
    setSelectedStatus('');
  }

  const hasActiveFilters = searchInput || selectedGroup || selectedStatus;

  return (
    <Grid className="questions-filters">
      <Grid.Row>
        <Grid.Column width={5}>
          <Input
            fluid
            icon="search"
            iconPosition="left"
            placeholder="Search questions or answers..."
            value={searchInput}
            onChange={onSearchChange}
          />
        </Grid.Column>
        <Grid.Column width={3}>
          <Dropdown
            fluid
            selection
            placeholder="Filter by Group"
            options={groupOptions}
            value={selectedGroup}
            onChange={onGroupFilterChange}
          />
        </Grid.Column>
        <Grid.Column width={3}>
          <Dropdown
            fluid
            selection
            placeholder="Filter by Status"
            options={statusOptions}
            value={selectedStatus}
            onChange={onStatusFilterChange}
          />
        </Grid.Column>
        <Grid.Column width={2}>
          <Button
            className="action-button-gray"
            fluid
            icon="eraser"
            content="Clear"
            onClick={onClearFilters}
            disabled={!hasActiveFilters}
          />
        </Grid.Column>
        <Grid.Column width={3} textAlign="right">
          <Button
            className="secondary-navy"
            icon="plus"
            content="Add Question"
            onClick={onCreateQuestion}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}

QuestionsFilters.propTypes = propTypes;
QuestionsFilters.defaultProps = defaultProps;
